// export this package's api
import Drawer from './Drawer';

export default Drawer;


//////////////////
// WEBPACK FOOTER
// ./~/rc-drawer/es/index.js
// module id = 2534
// module chunks = 0